import { useMutation } from '@tanstack/react-query';
import { api } from 'src/constants/apiRoutes';
import { RollBackPORequestItem } from 'src/types/edi';
import axiosInstance from 'src/utils/axios';

const useRollBackPOsMutation = () =>
  useMutation({
    mutationFn: async (body: RollBackPORequestItem[]) => {
      await axiosInstance.post(api.rollBackPOs, body);
    },
  });

export default useRollBackPOsMutation;
